import {Component, Input} from "@angular/core";


@Component({
    selector: 'tfl-material-card',
    template: `
        <mat-card>
            <mat-card-header>
                <mat-card-title  [innerHtml] = "title">
                </mat-card-title>
                <mat-card-subtitle *ngIf="subtitle"  [innerHtml] = "subtitle">
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions>
                <div class="actions-container">
                    <ng-content></ng-content>
                </div>
            </mat-card-actions>
        </mat-card>
    `
})
export class MaterialCardComponent {
    @Input('title') title: string;
    @Input('id') id: number;
    @Input('subtitle') subtitle: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/card/material-card.component.ts